<template>
<li class="">
	<span>{{itemValues.name}}</span>
	<ul>
		<slot>

		</slot>
	</ul>

</li>

</template>

<script>
export default {
	name: 'SecondLayer',
	props: {
		itemValues: {
			type: Object,
			default () {
				return {
					name: "",
				}
			}
		},
	},
	components: {},
	data() {
		return {}
	},
	created() {

	},
	watch: {},
	computed: {},
	methods: {

	},
	mounted() {}
}

</script>

<style scoped lang="scss">
li {
    padding-left: 40px;
    position: relative;

    &::before {
        content: "";
        position: absolute;
		width: 3px;
		height: 3px;
        background-color: #000;
        border-radius: 100%;
        top: 6pt;
        left: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// SecondLayer.vue?3982d504